/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Product card custom quantity controls (.ctm_atc_btn)







(function() {
  "use strict";

  function setQtyBtnText(btn, text) {
    if (!btn) return;
    var inner = btn.querySelector(".loader-button__text");
    if (inner) {
      inner.textContent = String(text);
    } else {
      btn.textContent = String(text);
    }
  }

  function setQtyBtnLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.setAttribute("aria-busy", "true");
    } else {
      btn.removeAttribute("aria-busy");
    }
  }

  function getVariantIdFromWrapper(wrapper) {
    if (!wrapper) return 0;

    var minus = wrapper.querySelector(".custom_minus");
    var explicit = parseInt(minus?.getAttribute("data-proid") || "0", 10);
    if (explicit) return explicit;

    var productItem = wrapper.closest("product-item");
    var checkedSwatch = productItem?.querySelector('.product-item-meta__swatch-list .color-swatch__radio:checked');
    var swatchVariant = parseInt(checkedSwatch?.getAttribute("data-variant-id") || "0", 10);
    if (swatchVariant) return swatchVariant;

    return 0;
  }

  function setWrapperVariantId(wrapper, variantId) {
    if (!wrapper || !variantId) return;
    var minus = wrapper.querySelector(".custom_minus");
    if (minus) {
      minus.setAttribute("data-proid", String(variantId));
    }
  }

  function openMiniCartDrawer() {
    var miniCart = document.getElementById("mini-cart");
    if (miniCart) {
      miniCart.open = true;
    }
  }

  // Mirror the PDP behavior controlled by the theme setting
  // "Show add-to-cart message with Buy now button":
  //   - setting ON  → keep drawer closed, show inline toast (current behavior)
  //   - setting OFF → open the cart drawer after add, suppress the toast
  // The PDP wires this via the AddToCart button's data-open-cart-drawer
  // attribute; product cards have no such attribute so we read the global.
  function shouldOpenDrawerOnAdd() {
    var s = window.themeVariables && window.themeVariables.settings;
    if (!s) return false;
    return s.addToCartMessageFlow === false && s.cartType === "drawer";
  }

  function fireCartEvents(cartData, openMiniCart) {
    if (!cartData) return;
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: { cart: cartData }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: { cart: cartData, replacementDelay: 600, openMiniCart: !!openMiniCart }
    }));

    if (openMiniCart) {
      openMiniCartDrawer();
    }
  }

  function syncMobileBottomCartHasItems(cart) {
    var link = document.querySelector(".mobile-bottom-cart-link");
    if (!link || !cart) return;
    var count = typeof cart.item_count === "number" ? cart.item_count : parseInt(cart.item_count, 10) || 0;
    if (count > 0) {
      link.classList.add("has-items");
    } else {
      link.classList.remove("has-items");
    }
  }

  function syncCartQtyFromData(cart) {
    syncMobileBottomCartHasItems(cart);
    if (!cart || !Array.isArray(cart.items)) return;

    // SUM quantities per variant_id — Shopify can split a single variant into
    // multiple line items when different discounts apply to portions of the
    // total quantity (e.g. "Buy More, Save More" + "Buy 2 Get 1 Free"). Each
    // split line shows the same variant_id but with different keys/discounts.
    // Without summing, the qty button would show only the LAST line's qty
    // (typically 1) even when the cart actually has 2+ of the variant.
    var qtyMap = {};
    cart.items.forEach(function(item) {
      qtyMap[item.variant_id] = (qtyMap[item.variant_id] || 0) + item.quantity;
    });

    document.querySelectorAll(".ctm_atc_btn").forEach(function(wrapper) {
      var qtyBtn = wrapper.querySelector("button.atc_with_qty");
      var addBtn = wrapper.closest(".dataFlex")?.querySelector("button.atc");
      if (!qtyBtn) return;

      if (qtyBtn.getAttribute("aria-busy") === "true") return;

      var variantId = getVariantIdFromWrapper(wrapper);
      if (!variantId) return;

      setWrapperVariantId(wrapper, variantId);
      var qty = qtyMap[variantId] || 0;

      if (qty > 0) {
        setQtyBtnText(qtyBtn, qty);
        wrapper.classList.remove("hide");
        addBtn?.classList.add("hide");
      } else {
        wrapper.classList.add("hide");
        addBtn?.classList.remove("hide");
      }
    });
  }

  function syncCartQty(cartData) {
    if (cartData && Array.isArray(cartData.items)) {
      syncCartQtyFromData(cartData);
      return;
    }

    fetch(window.Shopify.routes.root + "cart.js")
      .then(function(response) {
        return response.json();
      })
      .then(syncCartQtyFromData)
      .catch(function(error) {
        console.error("Error syncing cart qty:", error);
      });
  }

  // Shopify can split a variant into multiple line items when discount tiers
  // apply only to part of the quantity (e.g. "Buy 2 Get 1 Free" + "Buy More
  // Save More"). cart/update.js with { variant_id: N } in that scenario can
  // apply N to *each* matching line, ballooning the total. To avoid that:
  //   • increment via cart/add.js   — always adds exactly 1 unit, Shopify
  //     resplits the discount lines as needed.
  //   • decrement via cart/change.js targeting a specific line item KEY,
  //     starting from the most recently added line.
  function updateCartQty(variantId, delta, qtyBtn) {
    if (!variantId) return;
    if (qtyBtn && qtyBtn.getAttribute("aria-busy") === "true") return;
    if (delta === 0) return;
    setQtyBtnLoading(qtyBtn, true);

    var root = window.Shopify.routes.root;
    var headers = { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" };

    var promise;
    if (delta > 0) {
      // Increment: cart/add.js with quantity 1.
      promise = fetch(root + "cart/add.js", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function(response) {
          if (!response.ok) throw new Error("Failed to add item");
          // /cart/add.js returns the added line item, not the full cart.
          return fetch(root + "cart.js", { credentials: "same-origin" }).then(function(r) { return r.json(); });
        });
    } else {
      // Decrement: read cart, find variant lines, decrement the LAST one.
      promise = fetch(root + "cart.js", { credentials: "same-origin" })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var variantLines = (cart.items || []).filter(function(item) {
            return item.variant_id === variantId;
          });
          if (!variantLines.length) return cart;
          var target = variantLines[variantLines.length - 1];
          var newQty = Math.max(0, (target.quantity || 0) - 1);
          return fetch(root + "cart/change.js", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({ id: target.key, quantity: newQty })
          }).then(function(response) {
            if (!response.ok) throw new Error("Failed to decrement");
            return response.json();
          });
        });
    }

    promise
      .then(function(cartData) {
        setQtyBtnLoading(qtyBtn, false);
        var openDrawer = delta > 0 && shouldOpenDrawerOnAdd();
        fireCartEvents(cartData, openDrawer);
        if (delta > 0 && !openDrawer) showAddedToCartToast();
      })
      .catch(function(error) {
        setQtyBtnLoading(qtyBtn, false);
        console.error("Error updating cart qty:", error);
      });
  }

  function addToCartFromCard(addBtn) {
    var wrapper = addBtn?.closest(".dataFlex")?.querySelector(".ctm_atc_btn");
    var qtyBtn = wrapper?.querySelector("button.atc_with_qty");
    var variantId = getVariantIdFromWrapper(wrapper);

    if (!wrapper || !qtyBtn || !variantId) return;

    if (addBtn.getAttribute("aria-busy") === "true") return;
    setQtyBtnLoading(addBtn, true);
    var root = window.Shopify.routes.root;
    var headers = { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" };
    fetch(root + "cart/add.js", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function(response) {
        if (!response.ok) throw new Error("Failed to add item");
        // /cart/add.js returns the added line item only; refetch /cart.js
        // for the full cart state (needed for accurate qty totals when the
        // discount engine splits the variant into multiple lines).
        return fetch(root + "cart.js", { credentials: "same-origin" }).then(function(r) { return r.json(); });
      })
      .then(function(cartData) {
        setQtyBtnLoading(addBtn, false);
        wrapper.classList.remove("hide");
        addBtn.classList.add("hide");
        // Compute actual total for this variant from the response — Shopify
        // may have split the variant into multiple discount-tier line items,
        // so reading the summed quantity is more reliable than hardcoding 1.
        var totalForVariant = 0;
        if (cartData && Array.isArray(cartData.items)) {
          cartData.items.forEach(function(item) {
            if (item.variant_id === variantId) totalForVariant += item.quantity;
          });
        }
        setQtyBtnText(qtyBtn, totalForVariant || 1);
        var openDrawer = shouldOpenDrawerOnAdd();
        fireCartEvents(cartData, openDrawer);
        if (!openDrawer) showAddedToCartToast();
      })
      .catch(function(error) {
        setQtyBtnLoading(addBtn, false);
        console.error("Error adding item from product card:", error);
      });
  }

  // Fly-in/out toast shown when an item is added from a product card.
  // Replaces the cart drawer auto-open for product-card add-to-cart actions.
  var toastTimeoutId = null;
  function ensureToastStyles() {
    if (document.getElementById("beco-atc-toast-styles")) return;
    var style = document.createElement("style");
    style.id = "beco-atc-toast-styles";
    style.textContent = [
      // Toast pinned to bottom of viewport. On mobile it sits above the
      // .mobile-bottom-nav (which is ~80px tall) so it doesn't get covered.
      ".beco-atc-toast{position:fixed;    min-width: max-content;bottom:96px;left:50%;transform:translate(-50%,160%);",
      "background:#000;color:#00ff00;font-family:Montserrat,sans-serif;font-size:14px;font-weight:600;",
      "padding:12px 20px;border-radius:999px;box-shadow:0 6px 20px rgba(0,0,0,.2);z-index:100000;",
      "opacity:0;pointer-events:none;transition:transform .35s cubic-bezier(.2,.9,.3,1.2),opacity .25s ease;}",
      ".beco-atc-toast.is-visible{transform:translate(-50%,0);opacity:1;}",
      // Desktop: no mobile-bottom-nav, sit closer to the viewport edge.
      "@media (min-width:768px){.beco-atc-toast{bottom:24px;}}",
      "@keyframes beco-cart-bump{0%{transform:scale(1);}30%{transform:scale(1.4);}60%{transform:scale(.85);}100%{transform:scale(1);}}",
      ".mobile-bottom-nav__cart-count.is-bumping{animation:beco-cart-bump .5s ease;}"
    ].join("");
    document.head.appendChild(style);
  }

  function showAddedToCartToast(message) {
    ensureToastStyles();
    var toast = document.getElementById("beco-atc-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.id = "beco-atc-toast";
      toast.className = "beco-atc-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message || "Product added to cart";
    requestAnimationFrame(function() { toast.classList.add("is-visible"); });
    if (toastTimeoutId) clearTimeout(toastTimeoutId);
    toastTimeoutId = setTimeout(function() {
      toast.classList.remove("is-visible");
    }, 1800);
  }

  // Animate the mobile bottom-nav cart count whenever it changes.
  var lastCartCount = null;
  function bumpMobileCartCount(newCount) {
    var el = document.querySelector(".mobile-bottom-nav__cart-count");
    if (!el) return;
    if (lastCartCount === null) {
      lastCartCount = newCount;
      return;
    }
    if (newCount !== lastCartCount) {
      ensureToastStyles();
      el.classList.remove("is-bumping");
      void el.offsetWidth; // restart animation
      el.classList.add("is-bumping");
      lastCartCount = newCount;
    }
  }
  document.documentElement.addEventListener("cart:updated", function(event) {
    var cart = event?.detail?.cart;
    if (cart && typeof cart.item_count !== "undefined") {
      bumpMobileCartCount(parseInt(cart.item_count, 10) || 0);
    }
  });
  document.addEventListener("DOMContentLoaded", function() {
    var el = document.querySelector(".mobile-bottom-nav__cart-count");
    if (el) lastCartCount = parseInt(el.textContent.trim(), 10) || 0;
  });

  document.addEventListener("click", function(event) {
    // Clicks on the middle qty display (button.atc_with_qty) — including its
    // inner loader-button text/spinner spans and SVG — should be a no-op.
    // Only the explicit + and - controls mutate the cart. Without this guard,
    // a stray click on the middle button would submit the surrounding product
    // form and navigate the page to /cart/add.
    var qtyDisplay = event.target.closest("button.atc_with_qty");
    if (qtyDisplay) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var plus = event.target.closest(".custom_plus");
    if (plus) {
      event.preventDefault();
      event.stopPropagation();
      var plusWrapper = plus.closest(".ctm_atc_btn");
      var plusQtyBtn = plusWrapper?.querySelector("button.atc_with_qty");
      var plusVariantId = getVariantIdFromWrapper(plusWrapper);
      updateCartQty(plusVariantId, 1, plusQtyBtn);
      return;
    }

    var minus = event.target.closest(".custom_minus");
    if (minus) {
      event.preventDefault();
      event.stopPropagation();
      var minusWrapper = minus.closest(".ctm_atc_btn");
      var minusQtyBtn = minusWrapper?.querySelector("button.atc_with_qty");
      var minusVariantId = getVariantIdFromWrapper(minusWrapper);
      updateCartQty(minusVariantId, -1, minusQtyBtn);
      return;
    }

    var addBtn = event.target.closest("button.atc");
    if (addBtn) {
      event.preventDefault();
      event.stopPropagation();
      addToCartFromCard(addBtn);
    }
  });

  document.documentElement.addEventListener("cart:updated", function(event) {
    syncCartQty(event?.detail?.cart);
  });

  document.documentElement.addEventListener("cart:refresh", function(event) {
    if (event?.detail?.cart) {
      syncMobileBottomCartHasItems(event.detail.cart);
    } else {
      fetch(window.Shopify.routes.root + "cart.js")
        .then(function(response) {
          return response.json();
        })
        .then(syncMobileBottomCartHasItems)
        .catch(function() {});
    }
  });

  // Keep data-proid synced with selected swatch variant before cart actions.
  document.addEventListener("change", function(event) {
    var swatch = event.target.closest(".product-item-meta__swatch-list .color-swatch__radio");
    if (!swatch) return;

    var productItem = swatch.closest("product-item");
    var wrapper = productItem?.querySelector(".ctm_atc_btn");
    var variantId = parseInt(swatch.getAttribute("data-variant-id") || "0", 10);
    if (wrapper && variantId) {
      setWrapperVariantId(wrapper, variantId);
    }
  });

  document.addEventListener("DOMContentLoaded", function() {
    syncCartQty();
  });
})();

/**
 * Vertical slide animation for mobile product USP ticker.
 * Targets .product-usps-ticker.desktop-hide only (horizontal marquee stays unchanged).
 */
(function initProductUspVerticalTicker() {
  var SLIDE_INTERVAL_MS = 2800;
  var SLIDE_DURATION_MS = 450;

  function destroyTicker(ticker) {
    if (ticker._uspTickerInterval) {
      clearInterval(ticker._uspTickerInterval);
      ticker._uspTickerInterval = null;
    }
    if (ticker._uspTickerResizeHandler) {
      window.removeEventListener("resize", ticker._uspTickerResizeHandler);
      ticker._uspTickerResizeHandler = null;
    }
    ticker.classList.remove("is-sliding");
    ticker.removeAttribute("data-usp-ticker-init");
  }

  function getSlideHeight(ticker) {
    var firstItem = ticker.querySelector(".product-usps-ticker__slides li");
    return firstItem ? firstItem.offsetHeight : 0;
  }

  function applyViewportHeight(ticker, height) {
    var viewport = ticker.querySelector(".product-usps-ticker__viewport");
    if (viewport && height > 0) {
      viewport.style.height = height + "px";
    }
  }

  function setupTicker(ticker) {
    destroyTicker(ticker);

    var slides = ticker.querySelector(".product-usps-ticker__slides");
    if (!slides) return;

    var items = slides.querySelectorAll("li");
    if (items.length <= 1) return;

    var slideHeight = getSlideHeight(ticker);
    applyViewportHeight(ticker, slideHeight);

    var clone = items[0].cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    slides.appendChild(clone);

    var currentIndex = 0;
    var totalItems = items.length;

    function goToSlide(index, animate) {
      if (animate) {
        ticker.classList.add("is-sliding");
      } else {
        ticker.classList.remove("is-sliding");
      }
      slides.style.transform = "translateY(-" + index * slideHeight + "px)";
    }

    function advanceSlide() {
      currentIndex += 1;
      goToSlide(currentIndex, true);

      if (currentIndex >= totalItems) {
        window.setTimeout(function() {
          goToSlide(0, false);
          currentIndex = 0;
        }, SLIDE_DURATION_MS);
      }
    }

    ticker._uspTickerInterval = window.setInterval(advanceSlide, SLIDE_INTERVAL_MS);

    ticker._uspTickerResizeHandler = function() {
      var updatedHeight = getSlideHeight(ticker);
      if (!updatedHeight) return;
      slideHeight = updatedHeight;
      applyViewportHeight(ticker, slideHeight);
      goToSlide(currentIndex, false);
    };
    window.addEventListener("resize", ticker._uspTickerResizeHandler);

    ticker.setAttribute("data-usp-ticker-init", "true");
  }

  var TICKER_SELECTOR = ".product-usps-ticker.desktop-hide[data-usp-ticker], .product-usps-ticker--card[data-usp-ticker]";

  function initAllTickers() {
    document.querySelectorAll(TICKER_SELECTOR).forEach(setupTicker);
  }

  document.addEventListener("DOMContentLoaded", initAllTickers);

  // Product cards can be injected after load (AJAX filtering, pagination,
  // recommendations) — initialize tickers inside any added content.
  document.addEventListener("DOMContentLoaded", function() {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          var tickers = [];
          if (node.matches && node.matches(TICKER_SELECTOR)) tickers.push(node);
          if (node.querySelectorAll) {
            node.querySelectorAll(TICKER_SELECTOR).forEach(function(t) { tickers.push(t); });
          }
          tickers.forEach(function(ticker) {
            if (!ticker.hasAttribute("data-usp-ticker-init")) setupTicker(ticker);
          });
        });
      });
    });
    observer.observe(document.body, {childList: true, subtree: true});
  });

  document.querySelectorAll('form[id*="product-form"]').forEach(function(form) {
    form.addEventListener("product:rerender", function() {
      window.setTimeout(initAllTickers, 50);
    });
  });
})();
